import { createAsyncThunk } from '@reduxjs/toolkit';
import createGenericSlice, { GenericState } from '../wrapper/sliceWrapper';
import IUserList from '../../utils/UserList/UserList.interface';
import OrgUser from '../../utils/OrgUser/OrgUser';
import OrganizationAdmin from '../../utils/OrganizationAdmin/OrganizationAdmin';

const initialState: GenericState<Array<IUserList> | null> = { data: null, status: 'loading' };

export const getAllUsers = createAsyncThunk('users/getAllUsers', async () => {
  // All users list
  const allUsersAndAdmins: Array<IUserList> = [];
  const orgUser = new OrgUser({ email: '' });
  const allUsers = await orgUser.getAllUser();
  // Fetch all users and push in list
  allUsers.forEach((user) => {
    if (user && user.email !== '') {
      allUsersAndAdmins.push(user);
    }
  });
  // Fetch all organization and admins and push in list
  const organizationAdmin = new OrganizationAdmin();
  const allAdmins = await organizationAdmin.getAllOrganization();
  allAdmins.forEach((admin) => {
    if (admin && admin.email !== '') {
      allUsersAndAdmins.push(admin);
    }
  });
  return allUsersAndAdmins;
});

const userSlice = createGenericSlice({
  name: 'users',
  initialState,
  reducers: {
    // Reset state to initial state
    resetUsersState: (state) => {
      state = initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUsers.pending, (state) => {
      state.status = 'loading';
    });

    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.status = 'finished';
      state.data = action.payload.sort((a, b) => {
        const aval = a.email ?? '';
        const bval = b.email ?? '';
        return aval.localeCompare(bval);
      });
    });

    builder.addCase(getAllUsers.rejected, (state, action) => {
      state.status = 'error';
      state.data = action.payload as IUserList[] | null;
      state.error = 'Something went wrong.';
    });
  }
});

export const { resetUsersState } = userSlice.actions;
export default userSlice.reducer;
